<template>
  <svg
    :class="markOnly ? 'bb-brand-mark' : 'bb-brand-logo'"
    fill="none"
    :viewBox="markOnly ? '0 0 22 26' : '0 0 131 26'"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g v-if="markOnly" :clip-path="'url(#' + uid + '_m)'">
      <path
        d="M5.3784 0H0.728217C0.326657 0 0 0.326657 0 0.728217V6.90558C0 7.30714 0.326657 7.63379 0.728217 7.63379H6.10662V0.728217C6.10662 0.326657 5.77996 0 5.3784 0Z"
        fill="#F68F15"
      />
      <path
        d="M6.10662 7.63379V13.0122C6.10662 13.4138 6.43328 13.7404 6.83484 13.7404H12.2403C13.9277 13.7404 15.2946 15.1074 15.2946 16.7948C15.2946 18.4821 13.9277 19.8491 12.2403 19.8491H7.63379C6.79114 19.8491 6.10662 19.1667 6.10662 18.3219V14.4707C6.10662 14.0691 5.77996 13.7425 5.3784 13.7425H0.728217C0.326657 13.7425 0 14.0691 0 14.4707V19.1209C0 19.5225 0.326657 19.8491 0.728217 19.8491H4.57944C5.4221 19.8491 6.10662 20.5336 6.10662 21.3763V25.2275C6.10662 25.6291 6.43328 25.9557 6.83484 25.9557H11.8762C17.136 25.9557 21.4013 21.6925 21.4013 16.4307C21.4013 11.5724 17.4626 7.63379 12.6044 7.63379H6.10662Z"
        fill="currentColor"
      />
    </g>
    <g v-else :clip-path="'url(#' + uid + '_f)'">
      <path
        d="M5.40038 0H0.73112C0.327217 0 0 0.326486 0 0.729486V6.91749C0 7.32049 0.327217 7.64697 0.73112 7.64697H6.1315V0.729486C6.1315 0.326486 5.80429 0 5.40038 0Z"
        fill="#F68F15"
      />
      <path
        d="M6.13151 7.64698V13.0353C6.13151 13.4383 6.45872 13.7648 6.86262 13.7648H12.2891C13.9821 13.7648 15.3546 15.1342 15.3546 16.8235C15.3546 18.5127 13.9821 19.8822 12.2891 19.8822H7.6641C6.81758 19.8822 6.1315 19.1977 6.13113 18.353V14.4939C6.13113 14.0909 5.80392 13.7644 5.40001 13.7644H0.73112C0.327217 13.7644 0 14.0909 0 14.4939V19.1523C0 19.5553 0.327217 19.8818 0.73112 19.8818H4.59854C5.44506 19.8818 6.13151 20.5667 6.13151 21.4114V25.2701C6.13151 25.6731 6.45872 25.9996 6.86262 25.9996H11.9235C17.2048 25.9996 21.4861 21.7278 21.4861 16.4584C21.4861 11.5919 17.532 7.64661 12.6546 7.64661H6.13151V7.64698Z"
        fill="currentColor"
      />
      <path d="M51.2162 10.9534H47.0815V25.5903H51.2162V10.9534Z" fill="currentColor" />
      <path d="M51.2162 5.79688H47.0815V9.92233H51.2162V5.79688Z" fill="currentColor" />
      <path
        d="M59.2177 8.8909H55.083V21.3416C55.083 23.6882 56.9897 25.5907 59.3417 25.5907H62.6682V22.5335H60.8356C59.9421 22.5335 59.2177 21.8107 59.2177 20.9192V14.2762H62.6682V11.1822H59.2177V8.8909Z"
        fill="currentColor"
      />
      <path
        d="M74.3035 10.9534C72.7918 10.9534 71.3861 11.4055 70.2139 12.181V8.89051H70.218V5.79651H64.2339V8.89051H66.0792V25.5903H70.2139V24.5121C71.3861 25.2876 72.7918 25.7396 74.3035 25.7396C78.3958 25.7396 81.7134 22.4295 81.7134 18.3463C81.7134 14.2632 78.3958 10.9531 74.3035 10.9531V10.9534ZM74.0623 22.3325C72.2278 22.3325 70.6826 21.099 70.2139 19.4175C70.119 19.0766 70.068 18.7178 70.068 18.3467C70.068 17.9757 70.119 17.6165 70.2139 17.2759C70.6829 15.5948 72.2282 14.3609 74.0623 14.3609C76.2683 14.3609 78.057 16.1453 78.057 18.3467C78.057 20.5482 76.2687 22.3325 74.0623 22.3325Z"
        fill="currentColor"
      />
      <path
        d="M94.917 12.181C93.7447 11.4055 92.3391 10.9534 90.8273 10.9534C86.7351 10.9534 83.4175 14.2636 83.4175 18.3467C83.4175 22.4298 86.7351 25.74 90.8273 25.74C92.3391 25.74 93.7447 25.288 94.917 24.5124V25.5907H99.0517V11.1822H94.917V12.1814V12.181ZM94.917 19.4175C94.4479 21.0986 92.9027 22.3325 91.0686 22.3325C88.8625 22.3325 87.0738 20.5482 87.0738 18.3467C87.0738 16.1453 88.8622 14.3609 91.0686 14.3609C92.9031 14.3609 94.4483 15.5944 94.917 17.2759C95.0119 17.6169 95.0629 17.9757 95.0629 18.3467C95.0629 18.7178 95.0119 19.0769 94.917 19.4175Z"
        fill="currentColor"
      />
      <path
        d="M128.343 20.0081H130.811C130.934 19.474 130.999 18.918 130.999 18.3467C130.999 17.8564 130.951 17.3777 130.86 16.9141C130.191 13.5167 127.19 10.9534 123.59 10.9534C119.497 10.9534 116.18 14.2636 116.18 18.3467C116.18 22.4298 119.242 25.74 123.59 25.74C125.965 25.74 128.292 25.0495 130.043 23.2109L127.68 20.8535C126.923 21.8307 125.082 22.5713 123.493 22.5713C121.799 22.5713 120.343 21.4615 119.702 20.0077H128.342L128.343 20.0081ZM119.61 16.9141C120.193 15.3389 121.712 14.2161 123.493 14.2161C125.275 14.2161 126.794 15.3389 127.377 16.9141H119.61Z"
        fill="currentColor"
      />
      <path
        d="M109.204 17.0319C104.541 16.6259 106.015 14.9727 106.015 14.9727C106.015 14.9727 107.218 12.9387 112.58 15.2096L113.981 12.2843C113.981 12.2843 111.143 10.7224 107.183 11.1187C101.736 11.6636 101.857 15.2096 101.857 15.4953C101.857 16.5676 101.905 19.1847 106.482 19.8369C107.469 20.0059 110.51 20.0289 110.489 21.3638C110.468 22.6226 107.44 23.6017 102.884 21.294L101.459 24.235C101.459 24.235 103.748 25.8202 108.094 25.8202C112.439 25.8202 114.46 23.3495 114.46 21.3215C114.46 19.4235 113.711 17.4248 109.203 17.0322L109.204 17.0319Z"
        fill="currentColor"
      />
      <path
        d="M40.9608 15.1899C42.2592 14.3126 43.159 13.0041 43.1843 11.3884C43.1601 8.29622 40.6414 5.79688 37.5367 5.79688H28.6885V25.5903H37.9563C41.1711 25.5903 43.7769 23.1931 43.7769 19.9854C43.7769 18.0741 42.5954 16.3064 40.9604 15.1899H40.9608ZM36.5033 8.89087C37.9105 8.89087 39.0511 10.0289 39.0511 11.4329C39.0511 12.8369 37.9105 13.975 36.5033 13.975H32.8235V8.89087H36.5033ZM39.643 19.7826C39.643 21.2814 38.4253 22.4963 36.9233 22.4963H32.8235V17.0686H36.9233C38.4253 17.0686 39.643 18.2836 39.643 19.7823V19.7826Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath :id="uid + '_m'">
        <rect fill="currentColor" height="25.9537" width="21.3992" />
      </clipPath>
      <clipPath :id="uid + '_f'">
        <rect fill="currentColor" height="26" width="131" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "BrandLogo",
  props: {
    markOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uid: "bb" + Math.random().toString(36).slice(2, 9)
    };
  }
};
</script>
<style scoped>
.bb-brand-logo {
  height: 24px;
  width: 120px;
  display: block;
  color: currentColor;
  flex-shrink: 0;
}
.bb-brand-mark {
  height: 26px;
  width: 26px;
  display: block;
  color: currentColor;
}
</style>
